import raw from "../data/dataset.json";

export const dataset = raw;
export const summary = raw.summary;
export const cleaningFunnel = raw.cleaningFunnel;
export const q1 = raw.q1;
export const q2 = raw.q2;
export const q3 = raw.q3;
export const q4 = raw.q4;
export const q5 = raw.q5;
export const q6 = raw.q6;
